import tableBase from "../common/TableBase"


import { fetchTrendData } from "../common/FetchFilterData";
const url = "https://app.vantetider.se/spa/1.1/rest/regionQueries/intervalRegionTable";
class over90Table extends tableBase {
    constructor() {
        const template = document.createElement("form");
        template.style.position = 'relative';
        super(template);

        this.createPlaceholderTable();
        this.showSpinner(template);

        document.addEventListener("over90FilterSubmit", async e => {
            this.showSpinner(template)
            var params = e.detail;
            for (var property in params.values) {
                if (params.values.hasOwnProperty(property)) {
                    if (params.values[property] === "-1") {
                        delete params.values[property];
                    }
                }
            }
            try {
                const res = await fetchTrendData(url, params.values, 'series');
                var categories = ["Region"].concat(res.xNames);
                var series = [];
                res.series.forEach(s => {
                    series.push({
                        name: s.name,
                        data: s.data.map(data => {
                            return data.y;
                        }),
                        systemChange: s.data.map((data) => data?.systemChange == true )
                    })
                });
                this.createTable(categories, series, true);
                this.addFilterSearchOnClick("over90SearchReq");
                this.addSummary("Tabell som visar väntande/genomförda för olika regioner. ");
                this.addCaption(
                    "<b>" + params.text.production + "</b></br>" +
                    "<b>Indikator:</b> " + params.text.indicator + " " +
                    "<b>Region:</b> " + params.text.regions + " " +
                    "<b>Ägarform:</b> " + params.text.management + " " +
                    "<b>Vårdutbud:</b> " + params.text.service + " " +
                    "<b>Månad:</b> " + params.text.month + " " +
                    "<b>År:</b> " + params.text.year,
                    "tableTitle");
            } catch (error) {
                this.hideSpinner();
                console.error(err);
                this.errorNoData();
            }
        })
    }
}
if (!customElements.get("over90-table-region")) {
    tableBase.define("over90-table-region", over90Table);
}
